import {UserDefinedWidgetType} from '@constants/pages/user-defined-page/user-defined-widget-type';

export class WidgetDetails {
  widgetType: UserDefinedWidgetType = UserDefinedWidgetType.LINE_WITH_SIGNALS_PER_AXIS;
  widgetName: string = '';
  topX: number = 0;
  topY: number = 0;
  width: number = 3;
  height: number = 3;
}
